import axiosInstance from "../../../utils/axios";
import { ROLE } from "../../../utils/Constants";
const options = {role: ROLE.SUPER_ADMIN};

const path = "admin/lead"



export const List = async (values) => {
  return await axiosInstance(options).post(`${path}/list`, values);
};


export const Status = async (values) => {
    return await axiosInstance(options).patch(`${path}/change-status`, values);
};

export const Delete = async (values) => {
  return await axiosInstance(options).post(`${path}/delete`, values);  
};

export const Details = async (values) => {
  return await axiosInstance(options).post(`${path}/details`, values);  
};







